import type { ReactNode } from "react";
import type { FormStep1EnergyConsumption } from "@/types/Form";
import type { DataGridItem } from "@/pages/Summary/SummarySteps/DataGrid";

export const addToDataGrid = (
  id: string,
  label: string,
  value?: ReactNode | string,
  condition: boolean = true,
): DataGridItem[] => {
  if (!condition) return [];

  let normalizedValue: ReactNode | string = "-";

  if (typeof value === "string") {
    normalizedValue = value.trim().length > 0 ? value : "-";
  } else if (value !== undefined && value !== null) {
    normalizedValue = value;
  }

  return [{ id, label, value: normalizedValue }];
};

export const toEnergyConsumptionFormData = (payload: FormStep1EnergyConsumption) => {
  if (payload.profile_completion_form === "FILE_INPUT" && payload.file_input instanceof File) {
    const fd = new FormData();
    fd.append("profile_completion_form", payload.profile_completion_form);
    fd.append("file_input", payload.file_input);
    return fd;
  }

  const body: Record<string, unknown> = {
    profile_completion_form: payload.profile_completion_form,
    table_input: null,
    file_input: null,
    predefined_profile: null,
    usage_timeframe: null,
    usage_timeframe_value: null,
  };

  if (payload.profile_completion_form === "TABLE_INPUT" && payload.table_input?.length) {
    body.table_input = payload.table_input.map(Number);
  }

  if (payload.profile_completion_form === "PREDEFINED_PROFILE") {
    if (payload.predefined_profile) body.predefined_profile = payload.predefined_profile;
    if (payload.usage_timeframe) body.usage_timeframe = payload.usage_timeframe;
    if (payload.usage_timeframe_value != null) {
      body.usage_timeframe_value =
        typeof payload.usage_timeframe_value === "string"
          ? payload.usage_timeframe_value.replace(",", ".")
          : payload.usage_timeframe_value;
    }
  }

  return body;
};
